if(!customElements.get('header-dropdown')) {
  class HeaderDropdown extends HTMLElement {
    constructor() {
      super();
      this.level = Number(this.dataset.level);
      this.opener = this.querySelector(`[data-opener-level="${this.level}"]`);
      this.content = this.querySelector(`[data-opener-level="${this.level}"] + div`);
      this.parentDropdown = this.closest(`[data-level="${this.level-1}"`);

      this.bindEvents();
    }

    getHeight() {
      const openers = this.querySelectorAll(`[data-opener-level="${this.level + 1}"]`);
     
      if(!openers.length) return this.content.scrollHeight;
      
      let height = 0;
      openers.forEach(opener => height += opener.scrollHeight);
      return height;
    }

    bindEvents() {
      this.querySelectorAll('.menu-drawer__back-button').forEach((button) =>  {
        button.addEventListener('click', (event) => {
          this.closest('header-dropdown').removeAttribute('open')
        })
      });
    }

    connectedCallback() {
      if(!this.level || !this.opener || !this.content) return;

      this.contentInitialHeight = this.getHeight();
   
      this.content.style.height = '0px';

      this.opener.addEventListener('click', (event) => {
        event.stopPropagation();

        if(!this.parentDropdown) this.parentDropdown = this.closest(`[data-level="${this.level-1}"`);

        if(this.hasAttribute('open')) {
          this.removeAttribute('open');
          this.content.style.height = '0px';
          if(this.parentDropdown) {
            this.parentDropdown.content.style.height = this.parentDropdown.content.scrollHeight - this.contentInitialHeight + 'px';
          }
        } else {
          this.setAttribute('open', '');
          this.contentInitialHeight = this.getHeight();
          this.content.style.height = this.contentInitialHeight + 'px';
          if(this.parentDropdown) {
            this.parentDropdown.content.style.height = this.parentDropdown.content.scrollHeight + this.contentInitialHeight + 'px';
          }
        }
      });
    }
  }

  customElements.define('header-dropdown', HeaderDropdown);
}
